/* eslint-disable @typescript-eslint/no-use-before-define */
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import poJobNamesAPI from 'services/poJobNames'
import { PoJobNamesState } from 'typings/reduxStore'
import { ServerError } from 'typings/serverError'
import { PoJobNamesRequest } from './typings'

export const initState: PoJobNamesState = {
  response: [],
  isTransactionUpdated: false,
  isEditJobInvoicesRefresh: false,
  isInvoicesRefresh: false,
  isResponseFail: false,
  error: false,
  errorMessage: ''
}

export const updatePOJobNames = createAsyncThunk(
  'poJobNamesSlice/updatePOJobNames',
  async (payload: PoJobNamesRequest, { dispatch }) => {
    try {
      const { transactions: transactionsList } =
        await poJobNamesAPI.updatePOJobNames(payload)

      const updatedTransactions = transactionsList.filter(
        ({ updated }) => updated === true
      )

      dispatch(
        updatePOJobNameState({
          isTransactionUpdated: updatedTransactions.length > 0,
          isResponseFail: false,
          errorMessage: ''
        })
      )
    } catch (errorResponse) {
      const { response } = errorResponse as ServerError
      const { message } = response || {}

      dispatch(
        updatePOJobNameState({
          isResponseFail: true,
          errorMessage: message,
          isTransactionUpdated: false,
          isEditJobInvoicesRefresh: false
        })
      )
    }
  }
)

const poJobNamesSlice = createSlice({
  name: 'poJobNamesSlice',
  initialState: initState,
  reducers: {
    updatePOJobNameState: (
      state: PoJobNamesState,
      action: PayloadAction<PoJobNamesState>
    ) => {
      return {
        ...state,
        ...action.payload
      }
    },
    updatePOJobNamesReset: () => {
      return {
        ...initState
      }
    }
  }
})

export const { updatePOJobNameState, updatePOJobNamesReset } =
  poJobNamesSlice.actions

export default poJobNamesSlice.reducer
